import axios from '@/services/httpClient';
import { useAuthStore } from '@/stores/authStore';

/**
 * Upload an artifact mask
 * @param {string} organizationUuid - The organization UUID
 * @param {string} maskType - The type of mask
 * @param {File} imageFile - The image file to upload
 * @returns {Promise} - The response from the API
 */
export async function uploadArtifactMask(organizationUuid, maskType, imageFile) {
  try {
    const authStore = useAuthStore();
    
    // Create FormData object for multipart/form-data
    const formData = new FormData();
    formData.append('image_file', imageFile);
    
    const response = await axios.post(
      '/nora_superadmin/upload-artifact-mask', 
      formData, 
      {
        headers: {
          'Authorization': `Bearer ${authStore.accessToken}`,
          'Content-Type': 'multipart/form-data'
        },
        params: {
          organization_uuid: organizationUuid,
          mask_type: maskType
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error uploading artifact mask:', error);
    throw error;
  }
}

/**
 * Get artifact masks
 * @param {string} organizationUuid - The organization UUID
 * @param {string} [maskUuid] - Optional mask UUID to filter by specific mask
 * @returns {Promise} - The response from the API
 */
export async function getArtifactMasks(organizationUuid, maskUuid = null) {
  try {
    const authStore = useAuthStore();
    
    const params = {
      organization_uuid: organizationUuid
    };
    
    // Add mask_uuid to params if provided
    if (maskUuid) {
      params.mask_uuid = maskUuid;
    }
    
    const response = await axios.get(
      '/nora_superadmin/artifact-masks',
      {
        headers: {
          'Authorization': `Bearer ${authStore.accessToken}`
        },
        params
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error getting artifact masks:', error);
    throw error;
  }
}

/**
 * Deactivate an artifact mask
 * @param {string} maskUuid - The UUID of the mask to deactivate
 * @returns {Promise} - The response from the API
 */
export async function deactivateArtifactMask(maskUuid) {
  try {
    const authStore = useAuthStore();
    
    const response = await axios.patch(
      `/nora_superadmin/deactivate-artifact-mask/${maskUuid}`,
      {},  // Empty body for PATCH request
      {
        headers: {
          'Authorization': `Bearer ${authStore.accessToken}`
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error deactivating artifact mask:', error);
    throw error;
  }
}

// Also export as a default object for backward compatibility
export default {
  uploadArtifactMask,
  getArtifactMasks,
  deactivateArtifactMask
};

